<template>
  <el-dialog :visible.sync="isShow" width="360px" :show-close="false" :close-on-click-modal="false"
    custom-class="exchange-code-dialog" @closed="onClosed">
    <!-- 领取态 -->
    <div v-if="step === 'claim'" class="ec-claim">
      <div class="ec-card">
        <div class="ec-sender">
          <head-image :name="pack.nickName" :url="pack.headImage" :size="40" :isShowUserInfo="false"></head-image>
          <span class="ec-sender-name">{{ pack.nickName }}</span>
        </div>
        <div class="ec-title">{{ msg.content || "兑换码红包" }}</div>
        <div class="ec-sub">兑换码红包</div>
        <div class="ec-open-btn" :class="{ 'is-loading': claiming }" @click="onClaim">
          <span v-if="!claiming" class="ec-open-inner">开</span>
          <i v-else class="el-icon-loading"></i>
        </div>
        <div class="ec-open-tip">{{ claiming ? "领取中..." : "点击领取兑换码" }}</div>
      </div>
      <div class="ec-close" @click="close">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 详情态 -->
    <div v-else class="ec-detail">
      <div class="ec-detail-header">
        <head-image :name="pack.nickName" :url="pack.headImage" :size="42" :isShowUserInfo="false"></head-image>
        <div class="ec-detail-info">
          <div class="ec-detail-name">{{ pack.nickName }}</div>
          <div class="ec-detail-time">{{ pack.createTime }}</div>
        </div>
      </div>

      <div class="ec-number">
        <div class="ec-number-label">红包数量</div>
        <div class="ec-number-value">
          <span class="ec-number-num">{{ pack.number || 0 }}</span>
          <span class="ec-number-unit">个</span>
        </div>
        <div class="ec-tag">兑换码红包</div>
      </div>

      <div class="ec-records">
        <div class="ec-records-header">
          <span class="ec-records-title">领取详情</span>
          <span class="ec-records-count">{{ records.length }}/{{ pack.number || 0 }}个</span>
        </div>
        <div class="ec-records-list">
          <div class="ec-record" v-for="(item, index) in records" :key="index">
            <div class="ec-record-main">
              <head-image :name="item.nickName" :url="item.headImage" :size="32" :isShowUserInfo="false"></head-image>
              <div class="ec-record-info">
                <div class="ec-record-name">{{ item.nickName }}</div>
                <div class="ec-record-time">{{ item.createTime }}</div>
              </div>
            </div>
            <div class="ec-record-code">
              <span class="ec-code-text">{{ item.exchangeCode }}</span>
              <span class="ec-copy-btn" @click="copyCode(item.exchangeCode)">复制</span>
            </div>
          </div>
          <div v-if="records.length === 0" class="ec-empty">暂无领取记录</div>
        </div>
      </div>

      <div class="ec-footer">
        <div class="ec-btn" @click="close">关闭</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "ExchangeCodePopup",
  components: {
    HeadImage
  },
  data() {
    return {
      isShow: false,
      step: "claim", // claim: 领取态  detail: 详情态
      msg: {}, // 兑换码红包消息
      pack: {}, // 红包信息
      records: [], // 领取记录
      loading: false, // 是否正在查询红包状态
      claiming: false // 是否正在领取
    };
  },
  methods: {
    // 打开：先查询状态，未领取展示领取框，已领取/已领完/已过期直接展示详情
    open(msgInfo) {
      if (this.loading || this.claiming) {
        return;
      }
      this.msg = msgInfo || {};
      this.pack = {};
      this.records = [];
      this.loading = true;
      this.$http({
        url: "/message/group/exchangeCodeInfo/" + this.msg.id,
        method: "GET"
      })
        .then((res) => {
          this.pack = (res && res.pack) || {};
          this.records = (res && res.records) || [];
          this.step = this.pack.isOpen ? "detail" : "claim";
          this.isShow = true;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
    // 领取兑换码
    onClaim() {
      if (this.claiming) {
        return;
      }
      this.claiming = true;
      this.$http({
        url: "/message/group/getExchangeCode/" + this.msg.id,
        method: "GET"
      })
        .then(() => this.loadDetail())
        .catch(() => {
          // 领取失败(已领取/已领完/已过期)时，尝试直接展示详情
          return this.loadDetail().catch(() => { });
        })
        .finally(() => {
          this.claiming = false;
        });
    },
    // 查询领取详情
    loadDetail() {
      return this.$http({
        url: "/message/group/exchangeCodeInfo/" + this.msg.id,
        method: "GET"
      }).then((res) => {
        this.pack = (res && res.pack) || {};
        this.records = (res && res.records) || [];
        this.step = "detail";
      });
    },
    close() {
      if (this.claiming) {
        return;
      }
      this.isShow = false;
    },
    onClosed() {
      this.step = "claim";
      this.msg = {};
      this.pack = {};
      this.records = [];
    },
    copyCode(code) {
      if (!code) {
        return;
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(code)
          .then(() => this.$message.success("兑换码已复制到剪贴板"))
          .catch(() => this.fallbackCopy(code));
      } else {
        this.fallbackCopy(code);
      }
    },
    fallbackCopy(text) {
      let input = document.createElement("textarea");
      input.value = text;
      input.style.position = "fixed";
      input.style.opacity = 0;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.$message.success("兑换码已复制到剪贴板");
      } catch (e) {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(input);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .exchange-code-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

/* ==================== 领取态 ==================== */
.ec-claim {
  position: relative;

  .ec-card {
    padding: 24px 20px 28px;
    background: linear-gradient(135deg, #e54d42, #b71c1c);
    text-align: center;
  }

  .ec-sender {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding-bottom: 14px;
    border-bottom: 1px dashed rgba(255, 220, 200, 0.3);

    .ec-sender-name {
      font-size: 14px;
      color: #fff;
      font-weight: 600;
    }
  }

  .ec-title {
    margin-top: 20px;
    font-size: 17px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ec-sub {
    margin-top: 6px;
    font-size: 12px;
    color: #ffeadb;
  }

  .ec-open-btn {
    width: 90px;
    height: 90px;
    margin: 22px auto 0;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #ffd194, #fbae5c);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 6px 12px rgba(130, 0, 0, 0.3), 0 0 0 6px rgba(255, 209, 148, 0.3);

    .ec-open-inner {
      color: #8b4513;
      font-size: 36px;
      font-weight: 700;
    }

    .el-icon-loading {
      font-size: 30px;
      color: #8b4513;
    }

    &:hover {
      transform: scale(1.03);
    }

    &.is-loading {
      cursor: default;
    }
  }

  .ec-open-tip {
    margin-top: 12px;
    font-size: 13px;
    color: #fffaf5;
  }

  .ec-close {
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
    color: #999;

    &:hover {
      color: #666;
    }
  }
}

/* ==================== 详情态 ==================== */
.ec-detail {
  padding: 16px;

  .ec-detail-header {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;

    .ec-detail-info {
      margin-left: 10px;

      .ec-detail-name {
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }

      .ec-detail-time {
        margin-top: 4px;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .ec-number {
    padding: 16px 0;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;

    .ec-number-label {
      font-size: 12px;
      color: #999;
    }

    .ec-number-value {
      margin-top: 4px;

      .ec-number-num {
        font-size: 28px;
        font-weight: 600;
        color: #ff6b6b;
      }

      .ec-number-unit {
        margin-left: 4px;
        font-size: 13px;
        color: #ff6b6b;
      }
    }

    .ec-tag {
      display: inline-block;
      margin-top: 8px;
      padding: 2px 12px;
      border-radius: 16px;
      font-size: 12px;
      color: #ff6b6b;
      background: rgba(255, 107, 107, 0.1);
    }
  }

  .ec-records {
    padding-top: 12px;

    .ec-records-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .ec-records-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }

      .ec-records-count {
        font-size: 12px;
        color: #999;
      }
    }

    .ec-records-list {
      max-height: 220px;
      overflow-y: auto;
      margin-top: 8px;
    }

    .ec-record {
      padding: 10px 0;
      border-bottom: 1px solid #f5f5f5;

      &:last-child {
        border-bottom: none;
      }

      .ec-record-main {
        display: flex;
        align-items: center;

        .ec-record-info {
          margin-left: 10px;

          .ec-record-name {
            font-size: 13px;
            color: #333;
          }

          .ec-record-time {
            margin-top: 2px;
            font-size: 11px;
            color: #999;
          }
        }
      }

      .ec-record-code {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 8px;
        padding-left: 42px;

        .ec-code-text {
          flex: 1;
          min-width: 0;
          font-size: 13px;
          font-weight: 500;
          color: #ff6b6b;
          word-break: break-all;
        }

        .ec-copy-btn {
          flex-shrink: 0;
          margin-left: 10px;
          padding: 2px 12px;
          font-size: 12px;
          color: #ff6b6b;
          border: 1px solid #ff6b6b;
          border-radius: 14px;
          cursor: pointer;

          &:hover {
            background: rgba(255, 107, 107, 0.1);
          }
        }
      }
    }

    .ec-empty {
      padding: 24px 0;
      text-align: center;
      font-size: 13px;
      color: #999;
    }
  }

  .ec-footer {
    padding-top: 14px;
    text-align: center;

    .ec-btn {
      display: inline-block;
      min-width: 120px;
      padding: 7px 0;
      font-size: 13px;
      color: #fff;
      background: #e54d42;
      border-radius: 18px;
      cursor: pointer;

      &:hover {
        background: #d33c31;
      }
    }
  }
}
</style>
